<template>
  <div class="login-container">
    <banner :bannerUrl = 'bannerUrl'  :isBanner = 'isBanner' />
    <div class="main">
      <div class="title">
        <h3>展商证件申请</h3>
        <p>展商证申请移动平台</p>
      </div>
      <van-form ref="loginForm" @submit="onSubmit">
        <van-field
          v-model="user.username"
          name="username"
          placeholder="请输入用户名"
          :rules="userFormRules.username"
          class="inputLeft"
        >
          <i slot="left-icon" class="iconfont"><img :src="icon2" alt=""></i>
        </van-field>
        <van-field
          v-model="user.password"
          name="password"
          placeholder="请输入密码"
          :rules="userFormRules.password"
          class="inputLeft"
        >
        <i slot="left-icon" class="iconfont"><img :src="icon3" alt=""></i>
        </van-field>
        <!-- <div class="desc">
          <van-checkbox class="checkbox" v-model="ys1" icon-size="16" shape="square">
            用户必须浏览并同意
            <span @click.stop="show = true">隐私协议</span>
            方可登录
          </van-checkbox>
          <van-checkbox class="checkbox" v-model="ys2" icon-size="16" shape="square">
            用户必须浏览并同意
            <span @click.stop="show2 = true">防疫责任书</span>
            方可登录
          </van-checkbox>
        </div> -->
        <div class="login-btn-wrap">
          <van-button :loading='btnLoading' class="login-btn" block type="info" native-type="submit" :style="buttonStyle">
            登录
          </van-button>
          <!-- <van-button style="margin-top: 0.6rem;" class="login-btn" block type="info" @click="addMobileTo">
            补手机号
          </van-button> -->
        </div>
        <!-- <div class="tips">
          如非中国大陆展商/观众（无中国公民身份证）进入展馆，请务必随身携带护照、港澳台相关出入境证件等原件去现场进行信息登记，并遵循展会现场防疫须知相关规定，谢谢配合！
        </div> -->
      </van-form>
      <!-- /登录表单 -->
    </div>
    <!-- v-html="ShowMessage" -->
    <van-overlay :show="ShowMessageFalg" >
      <div class="vanoverlayContent">
        <div class="layTextBox" v-html="ShowMessage"></div>
        <div class="agressCheck">
          <van-checkbox v-model="agressCheckFalg" shape="square"  style="margin-right:10px">我已知晓</van-checkbox>
        </div>
        <div class="layBtn">
          <van-button type="info" @click="closeTip" :style="buttonStyle">确定</van-button>
        </div>
      </div>
    </van-overlay>
    <!-- <van-overlay :show="show" @click="show = false">
      <div class="wrapper">
        <h3>隐私政策相关条款</h3>
        <h3>原则</h3>
        <p>
          保护您的隐私对我们而言至关重要，因此，我们一定会遵守数据保护方面的强制性法规。下面向您简单介绍我们如何保护您的隐私数据。
        </p>
        <h3>个人数据</h3>
        <p>个人数据是指能够单独或者与其他信息结合明确确定您的身份的信息。我们向您收集的个人数据包括但不限于您的用户名、姓名、称谓、公司名称、所在部门、职位、省份、通讯地址、邮编、座机号、手机号、通讯语言和电子邮件地址等。我们只在您自愿提供时才保留此类个人数据使用。提交本《观众登记表》即意味着您知晓并同意主办方收集、储存和使用您的个人数据，以及将您的个人数据提供给其境内外的集团公司与合作伙伴储存和使用。</p>
        <h3>向第三方传递个人数据</h3>
        <p>主办方在一些服务中引入了一些高质量的合作伙伴。这些伙伴均遵守主办方在数据保护中所遵守的强制性规定。我们仅在如下情况下才向该等第三方传递个人数据</p>
        <p>• 在我们向您提供任何服务的过程中确实需要接受来自第三方的服务，而相关服务的提供依赖于您的个人数据；</p>
        <p>• 您已经事先给予许可的一些例外情况</p>
        <p>只有在有关法律法规或有权机关要求的范围内，个人数据才会被传递给相应有权机关。</p>
        <h3>发送商业信息</h3>
        <p>我们可能使用您的个人信息向您推送商业信息，包括但不限于通过信件、电子邮件、短信/彩信和电话。向我们提供您的个人信息，即表示您同意并知晓我们使用该个人信息向您推送商业信息。您可以通过推送中的相关指示退订该商业信息推送。</p>
        <h3>撤销权</h3>
        <p>您有权书面向主办方或其代表要求停止使用或删除您的个人数据。</p>
        <van-button class="tipsbtn" @click.stop="show = false" type="info">确定</van-button>
      </div>
    </van-overlay> -->
    <!-- <van-overlay :show="show2" @click="show2 = false">
      <div class="wrapper">
        <div style="" class="fangyiCon">
          <h3 style="text-align: center;">2020 慕尼黑上海电子展/慕尼黑上海电子生产设备展参展商须知</h3>
          <p>
            为了提供安全、健康、放心的参展环境，主办单位将根据《国务院应对新型冠状病毒感染肺炎疫情联防联控机制关于做好新冠肺炎疫情常态化防控工作的指导意见》中的要求，结合《上海市会展行业新冠肺炎疫情防控指南》相关规定，采取必要的防疫防护措施。<b>为了保护您和公众健康，现将具体措施告知如下，请各参展商知晓并严格遵守下列规定：</b>
          </p>
          <p>
            <b>1．</b>所有进入展馆的人员须在参展前做好自我健康状况监测，确保<b>1.本人及密切接触者无发热、咳嗽、乏力、腹泻等症状方可来沪；②来自/去过疫情重点地区人员进馆前须已完成 14 天隔离并持有 7 日内核酸检测阴性证明；③来自/去过北京低风险地区人员须持有 7 日内核酸检测阴性证明；④ 来沪前需做好个人健康申报，并生成绿色“随申码”（可通过微信“随申办”小程序或支付宝“健康码”版块办理）。没有绿色“随申码”的人员不得进入展馆。</b>
          </p>
          <p>
            <b>2．主办单位将不接受涉疫风险人员及来自疫情高风险地区的人员注册参展参会和进入展馆。</b>
          </p>
          <p>
            3．<b>所有进入展馆的人员须在展会开展前完成线上实名注册。</b>展商、观众、工作人员及其他参展人员通过相关的线上系统提供本人真实有效的身份证信息及手机联系方式，现场通过验证身份证原件， 确保“人证合一”后方允许入场。临时从海外或港澳台入境的人士须提供核糖核酸检测报告和解除 隔离通知书，出示护照、港澳居民来往内地通行证或台湾居民来往大陆通行证原件并拍摄照片留 底后，方能进入展馆。常驻中国的外籍人员或港澳台人士须在进馆前提前申请“随申码”，现场出 示护照、港澳居民来往内地通行证或台湾居民来往大陆通行证原件及绿色“随申码”，方可进入展 馆。
          </p>
          <p>
            4．所有进入展馆的人员必须携带本人身份证、港澳居民来往内地通行证、台湾居民来往大陆通行证或护照原件入场。未成年人禁止入场。
          </p>
          <p>
            5．<b>所有进入展馆范围的人员须统一采用“绿色“随申码”+测温正常+刷验身份证原件”的入场方式。</b>现场设置临时留验点，发现测温达到或超过 37.3℃的进场人员须配合主办单位前往临时留验点进行二次测温。如确定体温异常，须进行信息登记后及时离场并就医。出示绿色“随申码”及体温正常者可凭身份证原件扫描取得胸卡，并通过闸机刷验身份证原件后入场参展。
          </p>
          <p>
            <b>6．所有进入展馆的人员必须全程佩戴口罩，保持 1 米的安全社交距离，不聚集不簇拥，减少身体接触。</b>
          </p>
          <p>
            7．展会期间将在各展馆的主要出入口配置免洗消毒剂，以供参展及参观人员消毒使用。
          </p>
          <p>
            8．为保证展馆各区域空气流通，展馆各出入口大门敞开。
          </p>
          <p>
            <b>9．展会现场会议将限制参会人数、与会者必须全程佩戴口罩、现场座位将保持 1 米的间隔距离。</b>
          </p>
          <p>
            10．在指定的就餐区域或餐厅就餐，严禁聚集就餐。
          </p>
          <p>
            11．<b>所有参展参会人员应在正规的符合卫生防疫条件的宾馆住宿，做到在展期内尽量不去除展会场地之外人流密集的公共场所。外出必带口罩、勤洗手、保持社交距离、自觉遵守展馆和当地的各项防疫规定。</b>如遇突发情况，主办单位将按照疫情防控部门的规定对展会进行管控。
          </p>
          <p>
            <b>12．参展商须为自己的展位准备口罩、一次性手套、消毒水、免洗消毒剂等防疫消毒物品，并详列防疫物品清单。</b>
          </p>
          <p>
            <b>13．参展商须在参展全程正确佩戴口罩。安排防疫负责人实时对本展位工作人员、观众佩戴口罩情况、人员聚集情况进行巡查和引导，发现口罩脱摘和人员聚集及时进行提醒和引导。</b>
          </p>
          <p>
            <b>14．所有参商展、及其搭建商、运输商和其他展览服务人员除办理正常进场工作手续外，还需对其员工及供应商/服务商员工进行传染病预防知识常规培训，确保入场员工掌握消毒、清洁等必备防控知识和服务技能。</b>
          </p>
          <p>
            <b>15．参展商须建立信息台账，即参展工作人员健康档案、展位、展品及宣传资料通风消毒记录、人员管控记录等工作台帐，每日记录，加强工作管理。每日收集员工健康监测信息，做好记录。如有异常，及时向主办单位汇报。对于来自/去过疫情重点地区工作人员须提前确认健康状况，如有异常，及时告知主办单位。</b>
          </p>
          <p>
            <b>16．参展商防疫人员应严格落实通风措施。展位不得设置密闭房间，提倡敞开式设计。参展商应确保洽谈区通风、通气、宽敞，洽谈主宾双方应保持安全距离。严禁开展人群聚集性表演活动。如开展相关宣传活动，应控制活动的规模，做好人员密集时的分流限流措施，确保展位人群保持在安全距离。</b>
          </p>
          <p>
            17.参展商应配合主办单位、场馆方做好公共区域预防性消毒及日常消杀工作。严格落实本展位、展品及宣传资料预防性消毒和日常消杀工作并做好消毒工作记录。展商如发现进入展位洽谈的来宾体温异常，应及时报告现场疫情防控人员。
          </p>
          <p>
            18.主办单位严禁参展商开展人群聚集性表演活动。如开展相关宣传活动，应控制活动的规模，做好人员密集时的分流限流措施，确保展位人群保持在安全距离。
          </p>
          <p>
            19.参展商须确保所有派遣至展会现场工作人员、服务人员在指定的就餐区域或餐厅就餐，在正规的符合卫生防疫条件的宾馆住宿，做到在展期内尽量不去除展会场地之外，人流密集的公共场所。
          </p>
          <p>
            20.参展商应监督本展位展台搭建商落实各项防疫防控责任。敦促展台搭建商对内部工作人员及派遣至展会现场服务人员开展新冠肺炎防控知识及紧急情况处置技能培训；提前确认所有派遣至展会现场工作人员、服务人员的健康状况，按疾控部门要求，来自疫情高风险地区、或有疑似症状和其他传染性疾病的人员不得进入展会现场；加强内部管理，在展会现场实行每日健康监测和登记制度，汇总工作人员、服务人员健康情况，发现风险，立即隔离，及时向主办单位报告。
          </p>
          <p>
            21.闭馆后参展商需对展会期间人员的健康状况随访 14 天。若参展工作人员出现发热、干咳入院诊断为新型冠状病毒肺炎疑似、确诊以及无症状感染者病例，须及时告知主办单位，以便主办单位尽快配合疾控中心早期排查相关接触人员。
          </p>
          <p style="margin-top: 10px;">
            以上规定将根据上海市防控指南的更新而相应调整，请随时保持关注。
          </p>
          <p style="margin-top: 10px; text-align: right; margin-bottom: 10px;">
            更新于 2020 年 6 月 18 日
          </p>
        </div>
        <van-button class="tipsbtn" @click.stop="show2 = false" type="info">确定</van-button>
      </div>
    </van-overlay> -->
  </div>
</template>
<script>
import api from '@/api/api'
import reg from '@/utils/reg'
import banner from '@/components/banner'
import { setItem, getItem } from '@/utils/storage'
export default {
  name: 'LoginIndex',
  components: {
    banner
  },
  props: {},
  data () {
    return {
      banner: require('../../assets/banner.png'),
      icon2: require('../../assets/icon2.png'),
      icon3: require('../../assets/icon3.png'),
      ys1: false,
      ys2: false,
      show: false,
      show2: false,
      user: {
        username: '', // 用户名
        password: '' // 密码
      },
      userFormRules: {
        username: [{
          required: true,
          message: '用户名不能为空'
        }, {
          pattern: reg.notEmpty,
          message: '用户名不能都是空格'
        }],
        password: [{
          required: true,
          message: '密码不能为空'
        }, {
          pattern: reg.notEmpty,
          message: '密码不能都是空格'
        }]
      },
      isCountDownShow: false, // 是否展示倒计时,
      ExhID: '',
      btnLoading: false,
      exhName: '',
      isBanner: false,
      bannerUrl: '',
      buttonStyle: '',
      ShowMessage: '',
      ShowMessageFalg: false, //  是否有弹窗
      agressCheckFalg: '' //  是否勾选我已知晓
    }
  },
  computed: {},
  watch: {},
  created () {},
  mounted () {
    sessionStorage.clear()
    localStorage.clear()
    if (this.$route.query.ExhID) {
      this.$store.commit('Set_EXHID', this.$route.query.ExhID)
      sessionStorage.setItem('ExhID', this.$route.query.ExhID)
    }
    this.ExhID = this.$route.query.ExhID
    this.getselfbasicfield()
    this.getexhinfo()
  },
  methods: {
    addMobileTo () {
      this.$router.push('/addMobile')
    },
    getexhinfo () {
      api.getexhinfo({
        exhId: this.ExhID
      }).then(res => {
        if (res.data.code === 200) {
          setItem('exhName', res.data.data.exhName)
          this.exhName = res.data.data.exhName
          document.title = res.data.data.exhName
        } else {
          this.$toast.fail(res.data.msg)
        }
      })
    },
    closeTip () {
      if (this.agressCheckFalg) {
        this.ShowMessageFalg = false
      } else {
        this.$toast.fail('请勾先我已知晓')
      }
    },
    getselfbasicfield () {
      api.getselfbasicfield({
        exhId: this.ExhID
      }).then(res => {
        if (res.data.code === 200) {
          var _data = res.data.data
          for (var i = 0; i < _data.length; i++) {
            setItem(_data[i].scKey, _data[i].scValue)
          }
          this.isBanner = getItem('isBanner')
          this.bannerUrl = getItem('banner') || ''
          this.buttonStyle = getItem('buttonStyle') || ''
          this.ShowMessage = getItem('ShowMessage') || ''
          if (this.ShowMessage !== '') {
            this.ShowMessageFalg = true
          }
        } else {
          this.$toast.fail(res.data.msg)
        }
        this.init()
      })
    },
    init () {
      if (this.$route.query.atrCode) {
        api.getactorbycondition({
          exhId: this.ExhID,
          atrCode: this.$route.query.atrCode
        }).then(res => {
          if (res.data.code === 200) {
            setItem('token', res.data.data.token)
            setItem('exhibitor', res.data.data)
            this.$router.replace('/exhibitorCardAppli')
          } else {
            this.$toast.fail(res.data.msg)
          }
        })
      }
      if (this.$route.query.username && this.$route.query.password) {
        this.user.username = this.$route.query.username
        this.user.password = this.$route.query.password
        this.onSubmit()
      }
    },
    onSubmit () {
      // 验证用户名密码是否填写
      this.$toast.loading({
        message: '登录中...',
        forbidClick: true, // 禁用背景点击
        duration: 0 // 持续时间，默认 2000，0 表示持续展示不关闭
      })
      // if (!this.ys1) {
      //   this.$toast.fail('请阅读并选择隐私协议！')
      //   return
      // }
      // if (!this.ys2) {
      //   this.$toast.fail('请阅读并选择防疫责任书！')
      //   return
      // }
      const param = {
        loginName: this.user.username,
        loginPwd: this.user.password,
        exhId: this.ExhID
      }
      this.btnLoading = true
      api.login(param).then(res => {
        if (res.data.code === 200) {
          setItem('token', res.data.data.token)
          setItem('exhibitor', res.data.data)
          this.$router.push('/exhibitorCardAppli')
        } else {
          this.$toast.fail(res.data.msg)
          this.btnLoading = false
        }
      })
      this.$toast.clear()
    }
  }
}
</script>

<style lang="less">
.login-container {
  .van-field__value input{
    text-align: left;
  }
  .main{
    padding:1.2rem 0.4rem;
    min-height: 11rem;
    .title{
      h3{
        font-size: 0.46rem;
        font-weight: bold;
      }
      p{
        font-size: 0.3rem;
        color:#999;
        margin-top: 0.2rem;
      }
    }
    .van-form{
      margin-top:0.8rem;
      .van-cell {
        padding:0.27rem 0;
        font-size: 0.4rem;
        border-bottom: 1px solid #eee;
        margin-bottom: 0.3rem;
        .iconfont{
          img{
            width:0.66rem;
            margin-right: 0.2rem;
          }
        }
      }
    }
    .desc{
      font-size:0.38rem;
      .checkbox{
        padding:0.2rem 0;
        span{
          color:#3A6AD8;
        }
      }
    }
    .tips{
      color:red;
    }
  }
  .van-overlay{
    background:rgba(0, 0, 0, 0.5);
    .vanoverlayContent{
      position: absolute;
      background: #fff;
      width:82%;
      top:6%;
      left:0;
      right:0;
      margin: 0 auto;
      border-radius: 10px;
      padding: .4rem;
      max-height: 80%;
      height: 80%;
      overflow: hidden;
      overflow-y: auto;
    }
    .layTextBox{
      h4{
        text-align: center;
        padding:0.2rem 0;
        font-weight: bold;
        font-size: 0.5rem;
      }
      p{
        font-size: 0.4rem;
        text-indent: 0.8rem;
        line-height: 0.6rem;
      }
    }
    .agressCheck{
      display: flex;
      justify-content: center;
      padding:10px 0;
      .van-checkbox__label{
        text-decoration: underline;
        color: #1989fa;
      }
    }
    .layBtn{
      margin:auto;
      padding-top: 0.4rem;
      text-align: center;
      .van-button{
        width:50%;
        border-radius: 40px;
      }
    }
  }
  .toutiao {
    font-size: 37px;
  }
  .send-sms-btn {
    width: 152px;
    height: 46px;
    line-height: 46px;
    background-color: #ededed;
    font-size: 22px;
    color: #666;
  }
  .login-btn-wrap {
    padding:1rem 0;
    .login-btn {
      background-color: #108fd1;
      border: none;
      border-radius: 0.59rem;
      font-size: 0.4rem;
    }
  }
  .van-cell:not(:last-child)::after{
    border:0;
  }
}
@media screen and (min-width: 630px) {
  .login-container .main{
    padding:0.4rem;
    width: 50%;
    margin:0 auto;
  }
  .login-container .main .title h3{
    font-size: 0.3rem
  }
  .login-container .main .title p{
    font-size: 0.16rem
  }
  .login-container .main .van-form .van-cell{
    font-size: 0.24rem;
    padding: 0.2rem 0;
    margin:0;
    line-height: 0.48rem;
  }
  .login-container .main .van-form .van-cell .iconfont img{
    width: 0.36rem;
    margin:0;
  }
  .login-container .login-btn-wrap .login-btn{
    font-size: 0.24rem;
    height: 0.6rem;
    line-height: 0.6rem;
  }
  .van-button--block{
    width: 80%;
    margin:0 auto;
  }
  .inputLeft.van-field .van-field__value .van-field__error-message{
    font-size: 0.12rem;
    line-height: 0.16rem;
  }
}
</style>
